'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_content_Promise(icon, title, text) {
  this.hK = null;
  this.hM = null;
  this.hL = null;
  this.hK = icon;
  this.hM = title;
  this.hL = text;
}
export { $c_Lio_intela_sites_intelacloud_content_Promise as $c_Lio_intela_sites_intelacloud_content_Promise };
$p = $c_Lio_intela_sites_intelacloud_content_Promise.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_intelacloud_content_Promise;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_content_Promise() {
}
export { $h_Lio_intela_sites_intelacloud_content_Promise as $h_Lio_intela_sites_intelacloud_content_Promise };
$h_Lio_intela_sites_intelacloud_content_Promise.prototype = $p;
$p.O = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.q = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().V(this, (-203561201), true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_intelacloud_content_Promise)) {
    var x = this.hK;
    var x$2 = x$0.hK;
    if (((x === x$2) && (this.hM === x$0.hM))) {
      return (this.hL === x$0.hL);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.r = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().U(this);
});
$p.G = (function() {
  return 3;
});
$p.I = (function() {
  return "Promise";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.hK;
      break;
    }
    case 1: {
      return this.hM;
      break;
    }
    case 2: {
      return this.hL;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_intelacloud_content_Promise(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bD)));
}
export { $isArrayOf_Lio_intela_sites_intelacloud_content_Promise as $isArrayOf_Lio_intela_sites_intelacloud_content_Promise };
var $d_Lio_intela_sites_intelacloud_content_Promise = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_intelacloud_content_Promise, "io.intela.sites.intelacloud.content.Promise", ({
  bD: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_intelacloud_content_Promise as $d_Lio_intela_sites_intelacloud_content_Promise };
//# sourceMappingURL=io.intela.sites.intelacloud.content.-Promise.js.map
